<template>
  <div class="ushk-rili_week calendar-wrap-card">
    <div class="ushk-rili_calendar">
      <UshkDatePicker :value="date" @input="onDateChange">
        <div slot="right">
          <slot />
        </div>
      </UshkDatePicker>
    </div>

    <div class="ushk-rili_days">
      <a
        href="javascript:;"
        class="ushk-rili_week-btn ushk-rili_week-prev"
        @click="showPrevWeek"
      >
        <!-- <i class="ushk-icon ushk-icon_down"></i> -->
        <img class="icon-left" src="../../../assets/img/arrow.png" alt="">
        <span>上周</span>
      </a>

      <ul class="ushk-rili_week-list">
        <li
          v-for="(item, index) in days"
          :key="index"
          :class="{
            active: isActive(item.date)
          }"
        >
          <a href="javascript:;" @click="onDateClick(item.date)">
            <div class="week-warp">
              <span class="week week-ext">周{{ item.weekText }}</span>
              <span class="dd">{{ item.dayText }}</span>
            </div>
            <div class="dd-warp">
              <span class="mm-dd">{{ item.dateText }}</span>
              <span class="week">{{ item.weekText }}</span>
            </div>
          </a>
        </li>
      </ul>

      <a
        href="javascript:;"
        class="ushk-rili_week-btn ushk-rili_week-next is-active"
        @click="showNextWeek"
      >
        <span>下周</span>
        <!-- <i class="ushk-icon ushk-icon_down"></i> -->
        <img class="icon-right" src="../../../assets/img/arrow.png" alt="">
      </a>
    </div>
  </div>
</template>

<script>
import { prevDate, nextDate } from '@/commons/utils/date-util'
const ONE_DAY = 8.64e7
const WEEKS = ['日', '一', '二', '三', '四', '五', '六']

export default {
  props: {
    date: {
      type: Date,
      default() {
        return new Date()
      }
    },
  },
  data() {
    return {
      displayDate: this.date,
      weeks: [],
      nextWeeks: [],
      preWeeks: [],
      isShowPrevWeek: false,
      isShowNextWeek: false,
    }
  },
  watch: {
    date(val) {
      if (val.format('yyyyMMdd') === this.displayDate.format('yyyyMMdd')) {
        return false
      }

      this.displayDate = val
    }
  },
  computed: {
    days() {
      const currentDate = this.displayDate
      const timestamp = currentDate.getTime()
      const currentDay = currentDate.getDay()
      const days = []
      for (let i = 0; i < 7; i++) {
        const date = new Date(
          timestamp + ONE_DAY * (i - ((currentDay + 6) % 7)),
        )
        days.push({
          date,
          weekText: `${WEEKS[date.getDay()]}`,
          dateText: `${date.format('MM-dd')}`,
          dayText: `${date.format('dd')}`,
          key: date.format('yyyyMMdd'),
        })
      }
      return days
    },
  },
  created() {
  },
  methods: {
    onDateClick(date) {
      const dateStr = date.format('yyyy-MM-dd')
      this.$emit('dateChange', dateStr)
    },
    onDateChange(date) {
      location.href = `?date=${date.format('yyyy-MM-dd')}`
    },
    showPrevWeek() {
      this.displayDate = prevDate(this.displayDate, 7)
    },
    showNextWeek() {
      this.displayDate = nextDate(this.displayDate, 7)
    },
    isActive (date) {
      const DATE_FORMAT = 'yyyyMMdd'
      return this.date.format(DATE_FORMAT) === date.format(DATE_FORMAT)
    }
  },
}
</script>



// WEBPACK FOOTER //
// Week.vue?568dd196